/* ==========================================================================
   lm-native-filters.js  (TEST theme: native Shopify filtering instead of Boost)
   Loaded by sections/lmn-results.liquid on collection + search pages only.

   - Filter values, "Clear all", pagination and sorting update the page without a
     full reload: the section is fetched with the Section Rendering API
     (?section_id=...) and #lmn-root is swapped; the URL is updated with history.
   - Filter panel: desktop left column / <=1023px full-screen panel, both opened by the
     theme's "Filters" button (body.filter-opened, like before). "Show results (n)"
     closes the panel; "Clear all" removes every filter.
   - Group open/closed memory, "(n)" counts and arrows come from
     assets/live-match-collection.js (same as with Boost) - it works on the same classes.
   - Per-row toggle: localStorage "collectionPerRow" (global.js), re-applied after updates.
   - Old Boost filter URLs (pf_*, sort=) are converted to native filter.* params.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__lmnInit) return;
  window.__lmnInit = true;
  window.LMN_NATIVE = true;

  var MOBILE = window.matchMedia('(max-width: 1023px)');
  var ctrl = null;

  function root() { return document.getElementById('lmn-root'); }

  function cleanUrl(href) {
    var u = new URL(href, window.location.href);
    u.searchParams.delete('section_id');
    return u;
  }

  /* ------------------------------ per-row ------------------------------ */
  function applyPerRow() {
    var v = '4';
    try { v = localStorage.getItem('collectionPerRow') || '4'; } catch (e) {}
    if (v !== '4' && v !== '8') v = '4';
    var list = document.getElementById('lmn-product-list');
    if (list && list.getAttribute('data-perrow') !== v) list.setAttribute('data-perrow', v);
    document.querySelectorAll('#lmn-root .coll-bs-filter-toolbar-display-item').forEach(function (b) {
      b.classList.toggle('active', b.getAttribute('data-perrow') === v);
    });
  }

  function syncToggleState() {
    var open = document.body.classList.contains('filter-opened');
    document.querySelectorAll('#lmn-root .coll-bs-filter-box').forEach(function (b) {
      if (b.classList.contains('active') !== open) b.classList.toggle('active', open);
    });
  }

  function headerOffset() {
    var h = document.querySelector('.section-header, sticky-header, .header-wrapper');
    var bar = document.querySelector('#lmn-root .coll-bs-filter-wrapper');
    var off = 0;
    if (h) {
      var r = h.getBoundingClientRect();
      if (r.bottom > 0 && getComputedStyle(h).position !== 'static') off += Math.max(0, r.bottom);
    }
    if (bar && MOBILE.matches) off += 0;
    return off;
  }

  function scrollToResults() {
    var r = root();
    if (!r) return;
    var top = r.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  /* ------------------------------ render ------------------------------- */
  function load(url, opts) {
    opts = opts || {};
    var r = root();
    if (!r) { window.location.href = url.toString(); return; }
    var fetchUrl = new URL(url.toString());
    fetchUrl.searchParams.set('section_id', r.getAttribute('data-section-id'));
    if (ctrl) { try { ctrl.abort(); } catch (e) {} }
    ctrl = window.AbortController ? new AbortController() : null;
    r.classList.add('lmn-loading');
    fetch(fetchUrl.toString(), { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
      .then(function (res) { if (!res.ok) throw new Error(res.status); return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('lmn-root');
        if (!fresh) throw new Error('no root');
        var cur = root();
        var sc = cur.querySelector('.boost-sd__filter-tree-vertical-content');
        var col = cur.querySelector('.boost-filter-tree-column');
        var scTop = sc ? sc.scrollTop : 0;
        var colTop = col ? col.scrollTop : 0;
        for (var i = 0; i < fresh.attributes.length; i++) {
          var a = fresh.attributes[i];
          cur.setAttribute(a.name, a.value);
        }
        cur.classList.remove('lmn-loading');
        cur.innerHTML = fresh.innerHTML;
        var sc2 = cur.querySelector('.boost-sd__filter-tree-vertical-content');
        var col2 = cur.querySelector('.boost-filter-tree-column');
        if (sc2) sc2.scrollTop = scTop;
        if (col2) col2.scrollTop = colTop;
        if (opts.push !== false) {
          var clean = cleanUrl(url.toString());
          history.pushState({ lmn: 1 }, '', clean.pathname + clean.search + clean.hash);
        }
        afterRender();
        if (opts.scroll) scrollToResults();
        document.dispatchEvent(new CustomEvent('lmn:updated'));
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        window.location.href = cleanUrl(url.toString()).toString();
      });
  }

  function afterRender() {
    applyPerRow();
    syncToggleState();
    if (window.omWishlist && typeof window.omWishlist.refresh === 'function') {
      try { window.omWishlist.refresh(); } catch (e) {}
    }
  }

  /* ------------------------- tag groups (OR -> exclusive) ------------------------- */
  function tagGroupUrl(link) {
    var u = cleanUrl(link.getAttribute('href'));
    var group = link.getAttribute('data-tag-group');
    if (!group || link.getAttribute('aria-checked') === 'true') return u;
    // tag values from other groups would be OR-ed with this one: drop them
    var mine = {};
    document.querySelectorAll('#lmn-root a[data-tag-group="' + group + '"]').forEach(function (a) {
      mine[a.getAttribute('data-value')] = true;
    });
    var keep = u.searchParams.getAll('filter.p.tag').filter(function (v) { return mine[v]; });
    u.searchParams.delete('filter.p.tag');
    keep.forEach(function (v) { u.searchParams.append('filter.p.tag', v); });
    return u;
  }

  /* ------------------------------ clicks ------------------------------- */
  function closeSort() {
    document.querySelectorAll('#lmn-root .coll-bs-sort_by-box.active').forEach(function (b) { b.classList.remove('active'); });
    document.body.classList.remove('sorting-open');
  }
  function closePanel() {
    document.body.classList.remove('filter-opened');
    syncToggleState();
  }

  document.addEventListener('click', function (e) {
    var r = root();
    if (!r || !e.target.closest) return;
    var t = e.target;

    // "Filters" toggle
    var fbtn = t.closest('#lmn-root .coll-bs-filter-btn');
    if (fbtn) {
      e.preventDefault();
      document.body.classList.toggle('filter-opened');
      syncToggleState();
      return; // global.js "scroll to list" still runs (bubble phase)
    }

    // mobile panel: close X / Show results
    if (t.closest('#lmn-root .sh-boost-sf-pop-close') || t.closest('#lmn-root .lmn-show-results')) {
      e.preventDefault();
      e.stopPropagation();
      var showRes = !!t.closest('#lmn-root .lmn-show-results');
      closePanel();
      if (showRes) scrollToResults();
      return;
    }

    // sort: open/close
    var sbtn = t.closest('#lmn-root .coll-bs-sort_by-btn');
    if (sbtn) {
      e.preventDefault();
      e.stopPropagation();
      if (MOBILE.matches) {
        document.body.classList.add('sorting-open');
      } else {
        var box = sbtn.closest('.coll-bs-sort_by-box');
        if (box) box.classList.toggle('active');
      }
      return;
    }
    if (t.closest('#lmn-root .coll-bs-sort-custom-sorting')) {
      e.preventDefault();
      e.stopPropagation();
      closeSort();
      return;
    }
    var sortLink = t.closest('#lmn-root .bc-sf-filter-filter-dropdown a[data-sort]');
    if (sortLink) {
      e.preventDefault();
      e.stopPropagation();
      closeSort();
      var su = cleanUrl(window.location.href);
      su.searchParams.set('sort_by', sortLink.getAttribute('data-sort'));
      su.searchParams.delete('page');
      su.searchParams.delete('sort');
      load(su, { scroll: false });
      return;
    }
    // "Remove sorting preference" (mobile) is handled by live-match-collection.js (reloads without sort_by)

    // per-row toggle (global.js stores the value; we re-apply on our list)
    if (t.closest('#lmn-root .coll-bs-filter-toolbar-display-item')) {
      setTimeout(applyPerRow, 0);
      return;
    }

    // filter values, clear all, pagination
    var link = t.closest('#lmn-root a[data-lmn-link]');
    if (link) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      e.preventDefault();
      e.stopPropagation();
      var isPage = link.hasAttribute('data-lmn-page');
      var u = link.hasAttribute('data-tag-group') ? tagGroupUrl(link) : cleanUrl(link.getAttribute('href'));
      if (!isPage) u.searchParams.delete('page');
      load(u, { scroll: isPage });
      return;
    }

    // click outside the desktop sort dropdown closes it
    if (!t.closest('.coll-bs-sort_by-box')) {
      document.querySelectorAll('#lmn-root .coll-bs-sort_by-box.active').forEach(function (b) { b.classList.remove('active'); });
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var el = e.target;
    if (el && el.matches && el.matches('#lmn-root [role="button"]')) {
      e.preventDefault();
      el.click();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeSort(); if (MOBILE.matches) closePanel(); }
  });

  // price range form
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('#lmn-root form[data-lmn-price]');
    if (!f) return;
    e.preventDefault();
    var u = cleanUrl(window.location.href);
    f.querySelectorAll('input[name]').forEach(function (i) {
      if (i.value !== '') u.searchParams.set(i.name, i.value);
      else u.searchParams.delete(i.name);
    });
    u.searchParams.delete('page');
    load(u, { scroll: false });
  }, true);

  window.addEventListener('popstate', function () {
    if (!root()) return;
    load(cleanUrl(window.location.href), { push: false, scroll: false });
  });

  /* ------------------------- Boost URL -> native ------------------------- */
  // pf_* parameters used by Boost AI Search & Filter (V3) on this shop.
  var BOOST_MAP = {
    pf_v_brands: ['filter.p.vendor'],
    pf_v_vendor: ['filter.p.vendor'],
    pf_pt_product_type: ['filter.p.product_type'],
    pf_opt_size: ['filter.v.option.size'],
    pf_t_clothing: ['filter.p.tag'],
    pf_t_footwear: ['filter.p.tag'],
    pf_t_bags: ['filter.p.tag'],
    pf_t_accessories: ['filter.p.tag'],
    pf_t_sale: ['filter.p.tag'],
    pf_t_season: ['filter.p.m.custom.season', 'filter.p.tag'],
    pf_t_color: ['filter.p.m.shopify.color-pattern', 'filter.p.tag'],
    pf_t_material: ['filter.p.m.shopify.fabric', 'filter.p.tag'],
    pf_t_gender: ['filter.p.m.shopify.target-gender', 'filter.p.tag']
  };
  var DIRECT = { 'filter.p.vendor': 1, 'filter.p.product_type': 1, 'filter.v.option.size': 1, 'filter.p.tag': 1 };
  var BOOST_SORT = {
    'best-selling': 1, manual: 1, 'title-ascending': 1, 'title-descending': 1, 'price-ascending': 1,
    'price-descending': 1, 'created-ascending': 1, 'created-descending': 1, relevance: 1
  };

  function filterData() {
    try { return JSON.parse((document.getElementById('lmn-filter-data') || {}).textContent || '[]'); } catch (e) { return []; }
  }

  function mapBoostParams() {
    var u = new URL(window.location.href);
    var keys = [];
    u.searchParams.forEach(function (v, k) { if (/^pf_/.test(k) || k === 'sort') keys.push(k); });
    if (!keys.length) return false;
    var data = filterData();
    var byParam = {};
    data.forEach(function (f) { byParam[f.p] = f; });
    var unmapped = [];
    var seen = {};
    keys.forEach(function (k) {
      if (seen[k]) return;
      seen[k] = true;
      var vals = u.searchParams.getAll(k);
      u.searchParams.delete(k);
      if (k === 'sort') {
        if (BOOST_SORT[vals[0]]) u.searchParams.set('sort_by', vals[0]);
        return;
      }
      if (k === 'pf_p_price' || k === 'pf_p_prices') {
        var p = String(vals[0] || '').split(':');
        if (p[0]) u.searchParams.set('filter.v.price.gte', p[0]);
        if (p[1]) u.searchParams.set('filter.v.price.lte', p[1]);
        return;
      }
      if (/^pf_st_/.test(k)) {
        var inStock = vals.some(function (v) { return /in|true|1/i.test(v); });
        u.searchParams.set('filter.v.availability', inStock ? '1' : '0');
        return;
      }
      var targets = BOOST_MAP[k];
      if (!targets) {
        if (/^pf_t_/.test(k)) targets = ['filter.p.tag'];
        else if (/^pf_opt_/.test(k)) targets = ['filter.v.option.' + k.replace(/^pf_opt_/, '')];
        else if (/^pf_v_/.test(k)) targets = ['filter.p.vendor'];
        else if (/^pf_pt_/.test(k)) targets = ['filter.p.product_type'];
      }
      vals.forEach(function (raw) {
        var done = false;
        (targets || []).some(function (param) {
          var f = byParam[param];
          if (f) {
            var hit = (f.v || []).filter(function (pair) {
              return String(pair[1]).toLowerCase() === String(raw).toLowerCase() ||
                     String(pair[0]).toLowerCase() === String(raw).toLowerCase();
            })[0];
            if (hit) { u.searchParams.append(param, hit[0]); done = true; return true; }
          }
          return false;
        });
        if (!done && targets) {
          var direct = targets.filter(function (p) { return DIRECT[p] && byParam[p]; })[0];
          if (direct) { u.searchParams.append(direct, raw); done = true; }
        }
        if (!done) unmapped.push(k + '=' + raw);
      });
    });
    if (unmapped.length && window.console) console.info('[lm-native-filters] Boost filter not mapped:', unmapped.join(', '));
    window.location.replace(u.pathname + u.search + u.hash);
    return true;
  }

  /* -------------------------------- init -------------------------------- */
  function init() {
    if (!root()) return;
    document.body.classList.add('lmn-page');
    if (mapBoostParams()) return;
    if (history.replaceState) history.replaceState({ lmn: 1 }, '');
    afterRender();
    MOBILE.addEventListener && MOBILE.addEventListener('change', syncToggleState);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
